import request from '@/_helpers/requests/requestNotif'

export const dashboardService = {
    getAllNews() {
        return new Promise((resolve) => {
    
            request.get('dashboard').then(response => {
                resolve(response.data)
            });
        });
    },
    getAnuncioTypes() {
        return new Promise((resolve) => {
    
            request.get('dashboard/typeAnuncios').then(response => {
                resolve(response.data)
            });
        });
    },
    postNewAnuncio(anuncio, imagen) {
        return new Promise((resolve) => {
            request.post('dashboard/addAnuncio', {
                fecha: anuncio.fecha,
                hora: anuncio.hora,
                titulo: anuncio.titulo,
                tipoAnuncio: anuncio.tipoAnuncio,
                descTipoAnuncio: anuncio.descTipoAnuncio,
                fechaCaducidad: anuncio.fechaCaducidad,
                texto: anuncio.anuncio,
                imagen: imagen
            }).then(response => {
                resolve(response.status == 200);
            });
        });
    }
};